import { appParam } from '../appSettings';

export const C12_updateBankDetails = {
  steps: 1,
  C12001: {
    id: appParam.routing.C12_updateBankDetails.id + '001',
    progressTitle: '',
    progressValue: () => 100,
    title: 'Update your bank details',
    primaryButtonCaption: 'Update',
    next: appParam.routing.Userhome,
    cancel: appParam.routing.Userhome
  }
};
